
































import {
  Component,
  Ref,
  Vue,
} from 'vue-property-decorator';
import { formatErrorForNotification } from '@/utils/error';
import Breadcrumbs from '@/components/defaults/Breadcrumbs.vue';
import PageContainer from '@/components/defaults/PageContainer.vue';

import IPayrollHistoryFilter from '@/domain/interfaces/IPayrollHistoryFilter';
import PayrollRepository from '@/repositories/PayrollRepository';
import PayrollLog from '@/domain/models/PayrollLog';

import PayrollCardHeader from './components/PayrollCardHeader.vue';
import PayrollHistoryFilter from './components/PayrollHistoryFilter.vue';
import PayrollHistoryList from './components/PayrollHistoryList.vue';

@Component({
  components: {
    Breadcrumbs,
    PageContainer,
    PayrollCardHeader,
    PayrollHistoryFilter,
    PayrollHistoryList,
  },
})
export default class PayrollHistory extends Vue {
  @Ref('filter') filterComponent!: PayrollHistoryFilter;

  readonly payrollRepository: PayrollRepository = new PayrollRepository();

  showFilter: boolean = true;

  loading: boolean = false;
  items: Array<PayrollLog> = [];

  serverItemsLength: number = 0;
  data: IPayrollHistoryFilter = {} as IPayrollHistoryFilter;

  handleFilter(): void {
    const { valid, data } = this.filterComponent.validate();

    if (valid) {
      this.data = data;
      this.data.page = 1;

      const { companies, ...filters } = data;

      this.load(companies, filters);
    }
  }

  handleOnChangePage(page: number): void {
    this.data.page = page;
    this.reload();
  }

  handleOnChangeItemsPerPage(itemsPerPage: number): void {
    this.data.itemsPerPage = itemsPerPage;
    this.reload();
  }

  handleOnChangeSortBy(sortBy: string | Array<string>) {
    if (typeof sortBy === 'string') {
      this.data.sortBy = sortBy;
    }

    if (typeof sortBy === 'object' && Array.isArray(sortBy)) {
      const [by] = sortBy;
      this.data.sortBy = by;

      if (!by) {
        this.data.sortDesc = undefined;
      }
    }

    if (!this.loading) this.reload();
  }

  handleOnChangeSortDesc(sortDesc: boolean | Array<boolean>) {
    if (typeof sortDesc === 'boolean') {
      this.data.sortDesc = sortDesc;
    }

    if (typeof sortDesc === 'object' && Array.isArray(sortDesc)) {
      const [desc] = sortDesc;
      this.data.sortDesc = desc;
    }

    if (!this.loading && this.data.sortBy) this.reload();
  }

  reload(): void {
    if (!this.data) {
      this.$notification.warn('Sem filtros selecionados!');
      return;
    }

    const { companies, ...filters } = this.data;

    this.load(companies, filters);
  }

  async load(companies: Array<number>, filters: Omit<IPayrollHistoryFilter, 'companies'>): Promise<void> {
    try {
      this.loading = true;
      this.$dialog.startLoading();

      const groupId: number = this.$session.get('company_group_id');

      const params = {
        initial_date: filters.initialDate,
        end_date: filters.finalDate,
        types: filters.types,
        search: filters.search || undefined,
        per_page: filters.itemsPerPage,
        page: filters.page,
        sort_by: filters.sortBy,
        sort_desc: filters.sortDesc,
       };

      const response = await this.payrollRepository.getLogs(groupId, companies, params);

      this.items = response.data;
      this.serverItemsLength = response.meta.total ?? 0;

      if (!this.items.length) {
        this.$notification.warn('Nenhum resultado encontrado!');
        return;
      }

      this.showFilter = false;
    } catch (error: any) {
      const message = formatErrorForNotification(error);
      this.$notification.error(message);
    } finally {
      this.$dialog.stopLoading();
      this.loading = false;
    }
  }
}
